export default {
    blog_text_1: "Naše ",
    blog_text_2: "blogy",
    blog_text_3: "Ostatní články",

    p_packages_text_1: "FUNKCE DOFFERO",
    p_packages_text_2: "Co získám",
    p_packages_text_3: "Neomezené nabídky",
    p_packages_text_4: "Neomezený počet klientů",
    p_packages_text_5: "Vlastní",
    p_packages_text_6: "Nastav si vlastní barvy v designu nabídky.",
    p_packages_text_7: "barevné kombinace",
    p_packages_text_8:
        "Můžeš vytvořit uživatele, kteří mají přístup k tvému účtu.",
    p_packages_text_9: "Podúčty",
    p_packages_text_10: "pro kolegy či zaměstnance",
    p_packages_text_11:
        "Přidej si recenze svých klientů, které budou součástí nabídky.",
    p_packages_text_12: "Recenze",
    p_packages_text_13: "tvých klientů v nabídce",
    p_packages_text_14: "Nabídky",
    p_packages_text_15:
        "Pokud chceš, můžeš si skrýt naše logo ve svých nabídkách.",
    p_packages_text_16: "bez loga",
    p_packages_text_17: "DOFFERO",
    p_packages_text_18:
        "PREMIUM uživatelům nabízíme možnost vypracování vzhledu cenové nabídky na míru.",
    p_packages_text_19: "Vlastní šablony",
    p_packages_text_20: "cenové nabídky",
    p_packages_text_21:
        "Možnost přepnout nabídku do angličtiny, němčiny a slovenštiny",
    p_packages_text_22: "Možnost vložit obrázky k položkám",
    p_packages_text_23: "Možnost nahrát",
    p_packages_text_24:
        "Nahraj dokumenty nebo soubory, které si může tvůj zákazník stáhnout v online nabídce.",
    p_packages_text_25: "dokumenty ke stažení",
    p_packages_text_26: "Možnost nastavit si různé měny - EUR, CZK, USD, GBP",
    p_packages_text_27: "Možnost vytvářet cenové nabídky pod různými firmami",
    p_packages_text_28: "Možnost propojit DOFFERO® na",
    p_packages_text_29: "SuperFaktura.sk",
    p_packages_text_30: "Chci se zaregistrovat zdarma",
    p_packages_text_31: "Tvůj aktuální balíček",
    p_packages_text_32:
        "DOFFERO je aktuálně zdarma se všemi funkcemi. Žádné háčky.",
    p_packages_text_33: "a co ceny?",
    p_packages_text_34: "DOFFERO je",
    p_packages_text_35: "aktuálně pro",
    p_packages_text_36: "všechny zdarma",

    register_text_1: "Co ti dokážeme nabídnout?", // This line corresponds to the commented-out subtitle
    register_text_2: "Co oceníš na cenových nabídkách DOFFERO?",
    register_text_3: "Okouzlující design",
    register_text_4: "Krásný",
    register_text_5: "design",
    register_text_6: "Více nových zakázek",
    register_text_7: "Rychlá",
    register_text_8: "tvorba",
    register_text_9: "Propracované šablony",
    register_text_10: "Přizpůsobitelná",
    register_text_11: "barevnost",
    register_text_12: "Schválení na 1 klik",
    register_text_13: "Schválení",
    register_text_14: "na 1 klik",
    register_text_15: "na základě dotazníků od našich uživatelů",
    register_text_16:
        "Appku jsem použil na cca 10 nabídek a z toho 7 bylo úspěšných. Uvidíme, jak to půjde dál. :)",
    register_text_17: "Matej, programátor",

    register_text_19: "Ty jsi ještě nevyzkoušel/a naše cenové nabídky ZDARMA?",
    register_text_20: "Změň to! Stačí se zaregistrovat nebo se",
    register_text_21: "přihlas",
    register_text_22: "Jméno a příjmení",
    register_text_23: "Email",
    register_text_24: "Heslo",
    register_text_25: "8 znaků",
    register_text_26: "1 velké písmeno",
    register_text_27: "1 číslice",
    register_text_28: "Vytvořit účet",
    register_text_29: "Přečti si prosím podmínky",
    register_text_30: "zpracování osobních údajů",

    validation_text_1: "Jméno je povinný údaj.",
    validation_text_2: "Email je povinný údaj.",
    validation_text_3: "Zadejte správný formát emailu.",
    validation_text_4: "Email již existuje.",
    validation_text_5: "Heslo je povinný údaj.",
    validation_text_6: "Heslo musí obsahovat více než 8 znaků.",
    validation_text_7: "Je třeba udělit souhlas.",
    validation_text_8: "Název společnosti je povinný údaj.",

    // Registrace — onboarding kroky (0-6)
    reg_title_start: "Nastav si DOFFERO kompletně za méně než 90 sekund",
    reg_subtext_start:
        "Díky tomu budeš vytvářet cenové nabídky rychle a jednoduše. Začni jménem, e-mailem a heslem.",
    reg_email_label: "Emailová adresa",
    reg_login_link: "Přihlásit se",
    reg_terms_prefix: "Přečetl/a jsem si",
    reg_terms_link: "všeobecné obchodní podmínky",
    reg_terms_suffix: "a souhlasím s nimi",
    reg_continue: "Pokračovat",
    reg_consent_text: "Pokračováním v registraci souhlasím s",
    reg_consent_link: "Podmínkami zpracování osobních údajů",
    reg_users_bar_1: "DOFFERO důvěřuje už více než",
    reg_users_bar_2: "uživatelů",
    reg_step: "Krok",
    reg_step_back: "Krok zpět",

    reg_s1_hello: "Ahoj",
    reg_s1_question: ". Podnikáš?",
    reg_s1_subtext:
        "Pomoz nám poznat tě lépe. My ti na oplátku přesně přizpůsobíme DOFFERO.",
    reg_s1_type1_title: "Jsem podnikatel",
    reg_s1_type1_desc: "Jsem živnostník nebo vlastním s.r.o.",
    reg_s1_type2_title: "Nejsem podnikatel",
    reg_s1_type2_desc: "Momentálně nepodnikám",

    reg_s2_title_company: "Jak se jmenuje tvoje společnost?",
    reg_s2_title_brand: "Jak se jmenuje tvoje značka či projekt?",
    reg_s2_subtext_company:
        "Na základě jejího názvu se pokusíme najít údaje o společnosti, abychom ti usnadnili vyplňování.",
    reg_s2_subtext_brand:
        "Na základě názvu tvé značky ti připravíme profil v DOFFERO.",
    reg_s2_company_name: "Název společnosti",
    reg_s2_brand_name: "Název značky nebo projektu",
    reg_s2_more_info: "Více údajů o firmě",
    reg_s2_less_info: "Méně údajů o firmě",
    reg_s2_street: "Ulice a číslo sídla firmy",
    reg_s2_zip: "PSČ sídla firmy",
    reg_s2_city: "Město sídla firmy",
    reg_s2_vat_payer: "Jsem plátce DPH",
    reg_s2_vat_increase_1: "Navýšit ceny s",
    reg_s2_vat_increase_2: "DPH",
    reg_s2_verified: "Ověřeno",
    reg_s2_card_address: "Adresa",
    reg_s2_card_company: "společnosti",
    reg_err_dic_cz: "DIČ musí být ve tvaru CZ + 8 až 10 číslic.",
    reg_err_dic_sk: "DIČ musí mít 10 číslic.",
    reg_err_dph: "IČ DPH musí být ve tvaru např. SK1234567890.",
    reg_err_company_used: "Tento název společnosti se již používá",

    reg_s3_title_company: "Přizpůsob si DOFFERO \n přesně pro svou firmu",
    reg_s3_title_brand: "Přizpůsob si DOFFERO \n přesně pro svou značku",
    reg_s3_subtext_1: "Díky těmto informacím získáš",
    reg_s3_subtext_2: "s cenovými nabídkami profesionální výsledky.",
    reg_s3_business_type: "Typ podnikání",
    reg_s3_brand_area: "Oblast tvé značky",
    reg_select: "Vyberte",
    reg_s3_specify: "Umíš to upřesnit?",
    reg_s3_company_size: "Velikost firmy",
    reg_s3_how_many: "Kolik vás je?",
    reg_emp_1: "1 člověk",
    reg_emp_2: "2-4 lidé",
    reg_emp_3: "5-10 lidí",
    reg_emp_4: "10 - 50 lidí",
    reg_emp_5: "50 a více lidí",
    reg_biz_1: "Stavebnictví a řemesla",
    reg_biz_2: "Digitální / marketingová agentura",
    reg_biz_3: "Maloobchod a prodej",
    reg_biz_4: "Design a grafika",
    reg_biz_5: "IT, programování a software",
    reg_biz_6: "Foto / video produkce",
    reg_biz_7: "Finanční poradenství a pojišťovnictví",
    reg_biz_8: "Jiné",
    reg_err_business: "Vyberte alespoň jeden typ podnikání",
    reg_err_other_business: "Prosím, zadejte hodnotu pro jiné podnikání",
    reg_err_employees: "Vyberte počet zaměstnanců",

    reg_s4_title: "Vylaď si vzhled nabídek",
    reg_s4_subtext_company:
        "Nastav si logo, URL a barvu, aby ještě lépe prodávaly a reprezentovaly tvou firmu. Všechna nastavení si můžeš později upravit.",
    reg_s4_subtext_brand:
        "Nastav si logo, URL a barvu, aby ještě lépe prodávaly a reprezentovaly tvou značku. Všechna nastavení si můžeš později upravit.",
    reg_s4_logo: "Logo firmy",
    reg_s4_optional: "(Nepovinné)",
    reg_s4_logo_placeholder: "vlož nebo nahraj logo firmy",
    reg_s4_remove: "Odstranit",
    reg_s4_url: "Tvar URL",
    reg_s4_color: "Barva nabídek",
    reg_s4_custom_colors: "Vlastní barvy",
    reg_s4_basic_colors: "Základní barvy",
    reg_s4_toast_size: "Obrázek musí být menší než 2 MB!",
    reg_s4_toast_type: "Je možné nahrát pouze obrázek!",
    reg_s4_preview_title: "Cenová nabídka",
    reg_s4_preview_item1: "Projektové zadání",
    reg_s4_preview_item2: "Wireframes a design",
    reg_s4_preview_item3: "Projektový management",
    reg_s4_preview_total: "Celková cena",
    reg_err_url: "Prosím, zadejte URL adresu společnosti",
    reg_err_url_taken: "Tato URL adresa společnosti je již obsazena",

    reg_s5_title: "Vyber si svůj balíček",
    reg_s5_subtext:
        "Vyber si balíček, který tvému podnikání a procesům vyhovuje nejvíce.",

    reg_s6_status_1: "Vytváříme tvůj DOFFERO účet",
    reg_s6_status_2: "Nastavujeme vzhled tvých nabídek",
    reg_s6_status_3: "Vytváříme tvou první (ukázkovou) nabídku",

    login_text_1: "Doffero",
    login_text_2: "Vítej!",
    login_text_3: "Ještě nemáš účet?",
    login_text_4: "Zaregistruj se",
    login_text_5: "Zapomenuté heslo?",
    login_text_6: "Přihlásit se",
};
